/* eslint-disable global-require */
import angular from 'angular';

import './platform-forms.style.scss';
import { OnlinePlatformsFormController } from './platform-forms.controller';

export const FormOnlinePlatforms = {
  selector: 'formOnlinePlatforms',
  controller: OnlinePlatformsFormController,
  bindings: {
    exit: '&',
    show: '=',
    vehicle: '<',
  },
  template: /* html */ `
    <form class="default-form backdrop-overlay-form online-platforms-form" ng-submit="formTransmission()" ng-if="$ctrl.show">
      <div class="row">
        <div class="col-md-3">
          <div class="box-wrap">
            <div class="boxL">
              <vehicle-data-check [vehicle]="$ctrl.vehicle"></vehicle-data-check>
            </div>
          </div>
        </div>

        <div class="col-md-9">

          <div class="box-wrap">
            <div class="boxL">
              <div class="intro">
                <h3>Allgemeine Angaben zur Online-Anzeige</h3>
              </div>

              <div class="row">
                <div class="input-wrap col-md-12">
                  <input type="text" ng-model="$ctrl.formCommonApiData.title" placeholder="Titel des Inserats" required>
                  <label>Titel der Anzeige</label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 input-wrap" data-prefix="€">
                  <input ng-model="$ctrl.formData.onlinePrice" type="text" placeholder="Online Preis" required />
                  <label>Online Preis</label>
                </div>

                <div class="col-md-6 input-wrap">
                  <input ng-model="$ctrl.formCommonApiData.internalNumber" type="text" placeholder="Interne Nummer (optional)" />
                  <label>Interne Nummer (optional)</label>
                </div>
              </div>

              <div class="row checkbox-wrap">
                <!--<div class="checkbox col-lg-6">
                  <input type="checkbox" ng-model="$ctrl.formData.warranty" id="warranty">
                  <label for="warranty">Fahrzeug hat Garantie</label> 
                </div>-->

                <div class="checkbox col-lg-6">
                  <input type="checkbox" ng-model="$ctrl.formCommonApiData.dealersOnly" id="dealersOnly">
                  <label for="dealersOnly">Nur für andere Händler sichtbar</label> 
                </div>
              </div>

              <div class="divider"></div>

              <div class="subtitle">
                <span class="title-md">Beschreibung der Anzeige</span>
              </div>

              <div class="row">
                <div class="col input-wrap">
                  <rich-text-editor
                    ng-if="$ctrl.formData.showDescription"
                    custom-model="$ctrl.formCommonApiData.description.formatted"
                    custom-model-raw="$ctrl.formCommonApiData.description.raw"
                    placeholder="Hier kannst du eine Beschreibung für das Inserat hinzufügen"
                  ></rich-text-editor>
                </div>
              </div>

              <div class="btn-wrap">
                <button type="button" class="btn-lvl3" ng-click="$ctrl.addModelDescription()"><i class="fa-kit fa-solid-block-quote-circle-plus"></i> Technische Ausstattung</button>
                <button type="button" class="btn-lvl3" ng-click="$ctrl.addSeriesOptions()"><i class="fa-kit fa-solid-block-quote-circle-plus"></i> Serienoptionen (Hersteller)</button>
                <button type="button" class="btn-lvl3" ng-click="$ctrl.addAdditionalOptions()"><i class="fa-kit fa-solid-block-quote-circle-plus"></i> Aufpreisoptionen (Hersteller)</button>
              </div>

              <div class="divider"></div>

              <div class="subtitle">
                <span class="title-md">Highlights</span>
              </div>

              <div class="row" ng-repeat="highlight in $ctrl.formCommonApiData.highlights track by $index">
                <div class="input-wrap col-md-8">
                  <input type="text" ng-model="$ctrl.formCommonApiData.highlights[$index]" placeholder="Highlight (22 Zeichen)" maxlength="22">
                  <label>Highlight (22 Zeichen)</label>
                </div>

                <div class="btn-wrap col-md-4">
                  <button type="button" class="btn-icon" ng-click="$ctrl.removeHighlight($index)"><svg class="ab-icon"><use xlink:href="#btn-times"></use></svg></button>
                </div>
              </div>

              <div class="btn-wrap">
                <button type="button" class="btn-lvl3" ng-click="$ctrl.addHighlight()">
                  <svg class="ab-icon"><use xlink:href="#btn-add"></use></svg> Highlight hinzufügen
                </button>
              </div>

              <div class="divider"></div>

              <div class="subtitle">
                <span class="title-md">Angaben zur Verfügbarkeit</span>
              </div>

              <div class="row" ng-if="$ctrl.formData">
                <ab-datepicker
                  class="col-md-6 px-0"
                  selected-date="$ctrl.formData.deliveryDate"
                  required="false"
                  placeholder="Verfügbar ab (optional)"
                ></ab-datepicker>

                <div class="input-wrap col-md-6 select">
                  <select ng-model="$ctrl.formData.deliveryPeriod">
                    <option value="">Lieferzeitraum wählen (optional)</option>
                    <option value="1">1 Tag</option>
                    <option value="2">2 Tage</option>
                    <option value="3">3 Tage</option>
                    <option value="5">5 Tage</option>
                    <option value="6">6 Tage</option>
                    <option value="7">7 Tage</option>
                    <option value="14">14 Tage</option>
                    <option value="60">60 Tage</option>
                    <option value="90">90 Tage</option>
                    <option value="120">120 Tage</option>
                    <option value="150">150 Tage</option>
                    <option value="180">180 Tage</option>
                    <option value="270">270 Tage</option>
                    <option value="360">360 Tage</option>
                  </select>
                  <label>Verfügbar in (optional)</label>
                </div>
              </div>
            </div>

            <div class="boxL">
              <h3>
                Kanäle für die Veröffentlichung
              </h3>

              <!-- Add new ad -->

              <!-- Mobile.de Seller API -->
              <ng-container ng-if="$ctrl.apiAccounts.ready">
                <ng-container ng-if="$ctrl.apiAccounts.mobileSeller.length">
                  <div class="row">
                    <img src="img/logos/mobile-de-logo.svg" style="max-width: 7rem;">
                  </div>

                  <div class="row">
                    <div class="chips-wrap">
                      <div
                        class="chip"+
                        ng-class="{ 'active': item.publish }"
                        ng-repeat="item in $ctrl.apiAccounts.mobileSeller track by $index"
                        ng-click="$ctrl.changeMobileAccountState(item.id)"
                      >
                        <div class="icon" ng-if="item.publish">
                          <i class="fa-regular fa-check"></i>
                        </div>
                        <span>{{item.name}}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- AutoScout24 API -->
                <ng-container ng-if="$ctrl.apiAccounts.autoScout24.length">
                  <div class="divider"></div>

                  <div class="row">
                    <img src="img/logos/autoscout24-logo.svg" style="max-width: 7rem;">
                  </div>

                  <div class="row">
                    <div class="chips-wrap">
                      <div
                        class="chip"+
                        ng-class="{ 'active': item.publish }"
                        ng-repeat="item in $ctrl.apiAccounts.autoScout24 track by $index"
                        ng-click="$ctrl.changeAutoScout24AccountState(item.id)"
                      >
                        <div class="icon" ng-if="item.publish">
                          <i class="fa-regular fa-check"></i>
                        </div>
                        <span>{{item.name}}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- AWI API -->
                <ng-container ng-if="$ctrl.apiAccounts.awi.length">
                  <div class="divider"></div>

                  <div class="row">
                    <!--<img src="img/logos/autoscout24-logo.svg" style="max-width: 7rem;">-->
                    <span class="title-md">Händler-Website</span>
                  </div>

                  <div class="row">
                    <div class="chips-wrap">
                      <div
                        class="chip"+
                        ng-class="{ 'active': item.publish }"
                        ng-repeat="item in $ctrl.apiAccounts.awi track by $index"
                        ng-click="$ctrl.changeAWIAccountState(item.id)"
                      >
                        <div class="icon" ng-if="item.publish">
                          <i class="fa-regular fa-check"></i>
                        </div>
                        <span>{{item.name}}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>

              </ng-container>
            </div>

            <div class="boxL">
              <div class="row checkbox-wrap">
                <div class="checkbox col-lg-6">
                  <input type="checkbox" ng-model="$ctrl.formCommonApiData.deactivated" id="deactivated">
                  <label for="deactivated">Anzeige deaktivieren</label> 
                </div>

                <div class="col-lg-6 btn-wrap right">
                  <button type="button" ng-click="$ctrl.publishVehicle()" class="btn-lvl1" ng-class="{'btn-sending': $ctrl.formData.sending}" ng-disabled="$ctrl.formData.sending">Anzeige veröffentlichen</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  `,
};

export default angular.module('directives.formOnlinePlatforms', [])
  .component(FormOnlinePlatforms.selector, FormOnlinePlatforms)
  .name;
